import {combineReducers, configureStore} from '@reduxjs/toolkit';
import feedReducer from '@/redux/slices/reducers/feedReducer';

const rootReducer = combineReducers({
  feed: feedReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;